import * as React from "react";
import { NewModal } from "../uiMerge/newModal";
import { LoginConnector } from "../../modules/auth/login/LoginConnector";

interface LoginModalProps {
  visible: boolean;
  onCancel: () => void;
}

export const LoginModal: React.FC<LoginModalProps> = ({ visible, onCancel }) => {
  return (
    <NewModal
      colorClass="bg-black"
      showCloseButton={false}
      position="end"
      animationClass="grow-in"
      isOpen={visible}
      onClose={onCancel}
    >
      <LoginConnector />
    </NewModal>
  );
};